export default function (response) {
  if (response) {
    if (!!response.data.deactivated) {
      if (window.location.pathname !== '/login') {
        return window.location.href = '/login';
      }
    } else {
      return response.data
    }
  } else {
    toastr['error']('Ошибка', 'Ошибка');

    return window.location.href = '/login';
  }
}



// WEBPACK FOOTER //
// ./resources/js/helpers/responseService.js